var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "caleander2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.103,
    height: 17.873,
    viewBox: "0 0 20.103 17.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 20.103,
    height: 17.873,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M12.571,4.946a1.1,1.1,0,0,0,1.107-1.1V1.1a1.107,1.107,0,0,0-2.214,0V3.849a1.1,1.1,0,0,0,1.107,1.1",
    transform: "translate(-6.741 0)",
    fill: "#d51a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M33.1,4.946a1.1,1.1,0,0,0,1.107-1.1V1.1a1.107,1.107,0,0,0-2.214,0V3.849a1.1,1.1,0,0,0,1.107,1.1",
    transform: "translate(-18.812 0)",
    fill: "#d51a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M19.217,3.871h-2.04a.878.878,0,1,0,0,1.756h1.155V9.193H1.771V5.627H2.926a.878.878,0,1,0,0-1.756H.886A.882.882,0,0,0,0,4.749V19.278a.882.882,0,0,0,.886.878H19.217a.882.882,0,0,0,.886-.878V4.749a.882.882,0,0,0-.886-.878M1.771,10.51h16.56V18.4H1.771Z",
    transform: "translate(0 -2.283)",
    fill: "#d51a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M19.792,5.627h2.755a.878.878,0,1,0,0-1.756H19.792a.878.878,0,1,0,0,1.756",
    transform: "translate(-11.118 -2.283)",
    fill: "#d51a66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSmall);
export default __webpack_public_path__ + "static/media/calendar_Small.e2e5ef3d9cb3ca4f4604a55e5aad73e9.svg";
export { ForwardRef as ReactComponent };